import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const SummerQuizLoadable = Loadable({
    loader: (): any => import('./SummerQuiz').then((res) => res.SummerQuiz),
    loading: <Loader/>,
});
